<template>
  <div>
    <span v-if="rules.length===0">{{$t('pages.subgroups.editRules.thereAreNoRules')}}</span>
    <ul class="list-group">
      <li v-for="rule in rules" :key="rule.id" class="list-group-item">
        <div class="row my-margin">
          <div class="text-left">
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exIdentifier !== null && rule.exIdentifier.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.identifier')}}: {{rule.exIdentifier.split('%').join('')}}</span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exTitle !== null && rule.exTitle.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.title')}}: {{rule.exTitle.split('%').join('')}}</span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exAuthor !== null && rule.exAuthor.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.author')}}: {{rule.exAuthor.split('%').join('')}}</span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exSource !== null && rule.exSource.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.source')}}: {{rule.exSource.split('%').join('')}}</span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exTagIds !== null && rule.exTagIds.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.tags')}}:
                  <span v-for="tag in rule.exTagIds" class="label label-primary" style="margin-right: 3px">
                    {{tagName(tag)}}
                  </span>
                </span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exTagIds !== null && rule.exTagIds.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.tagFilter')}}: {{rule.exTagFilterType}}</span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exTagIds !== null && rule.exTagExcludeIds.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.excludedTags')}}:
                  <span v-for="tag in rule.exTagExcludeIds" class="label label-primary" style="margin-right: 3px">
                    {{tagName(tag)}}
                  </span>
                </span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exLngIds !== null && rule.exLngIds.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.languages')}}:
                  <span v-for="tag in rule.exLngIds" class="label label-primary" style="margin-right: 3px">
                    {{languageName(tag)}}
                  </span>
                </span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6" v-if="rule.exTypeIds !== null && rule.exTypeIds.length > 0">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.type')}}:
                  <span v-for="tag in rule.exTypeIds" class="label label-primary" style="margin-right: 3px">
                    {{typeName(tag)}}
                  </span>
                </span>
              </div>
            </div>
            <div class="panel panel-transparent col-sm-12 col-md-6">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.isOwner')}}: {{rule.exIsOwner ? $t('pages.subgroups.editRules.isTrue') : $t('pages.subgroups.editRules.isFalse')}}</span>
              </div>
            </div>
            <!-- <div class="panel panel-transparent col-sm-12 col-md-6">
              <div class="panel-body">
                <span>{{$t('pages.subgroups.editRules.isPublic')}}: {{rule.exIsPublic ? $t('pages.subgroups.editRules.isTrue') : $t('pages.subgroups.editRules.isFalse')}}</span>
              </div>
            </div> -->
          </div>
          <div class="btn-group pull-right" role="group">
            <button type="button" class="btn btn-secondary" style="color: black" @click.prevent="editRule(rule)"><i class="fa fa-gear"></i>  {{$t('pages.buttons.edit')}}</button>
            <button type="button" class="btn btn-danger" @click.prevent="deleteRuleModal(rule.id)"><i class="fa fa-trash"></i></button>
          </div>
        </div>
      </li>
      <li class="margin">
        <div class="col-xs-10">
          <button type="button" :disabled="rules.length > 0" class="btn btn-default pull-left" @click.prevent="addRule">
            <i class="fa fa-plus"></i> {{$t('pages.subgroups.editRules.addRule')}}
          </button>
        </div>
        <div class="col-xs-2">
          <div class="pull-right box-tools">
            <button type="button" class="btn btn-box-tool" @click.prevent="closeDropdown()"><i class="fa fa-caret-up"></i></button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
import draggable from 'vuedraggable'
import Rest from './../../../services/rest'
import Exercise from '@/components/exercises/Exercise.vue'
import { mapState } from 'vuex'
import vSelect from 'vue-select'
export default {
  /*
  computed: {
    exercisesForProgress: {
      get () {
        return this.$store.state.exercisesInOrder
      },
      set (value) {
        this.$store.dispatch('updateExerciseOrderInSubgroup', {
          val: value,
          pid: this.podgrupa.id
        })
      }
    }
  },
  */
  computed: {
    ...mapState({
      CelotnaNaloga: state => state.exerciseForModal,
      selectedExercises: state => state.exercises.selectedExercises,
      exercisesForProgress: state => state.exercisesForOrder
    })
  },
  data () {
    return {
      // exercisesForProgress: []
      rules: [],
      sid: '',
      sqlsid: '',
      stitle: '',
      sauthor: '',
      ssource: '',
      stags: [],
      sTagFilter: 'or',
      stagsExclude: [],
      slangs: [],
      stypes: [],
      sowner: true,
      spublic: false,
      options: {}
    }
  },
  props: {
    podgrupa: Object
  },
  created () {
    this.getOptions()
    this.getRules()
    /*
    this.$store.dispatch('exercisesForProgressGet', {
      pid: this.podgrupa.id,
      showVisible: true
    })
    */
    this.$store.dispatch('exercisesForOrderGet', {
      gid: this.$route.params.gid,
      yid: this.$route.params.yid,
      pid: this.podgrupa.id
    })
    // this.exercisesForProgressGet()
  },
  methods: {
    editRule (rule) {
      this.$parent.identifier = rule.exIdentifier.split('%').join('')
      this.$parent.stitle = rule.exTitle.split('%').join('')
      this.$parent.sauthor = rule.exAuthor.split('%').join('')
      this.$parent.ssource = rule.exSource.split('%').join('')
      this.$parent.stags = this.convertIdToTags(rule.exTagIds)
      this.$parent.stagsExclude = this.convertIdToTags(rule.exTagExcludeIds)
      this.$parent.slangs = this.convertIdToTags(rule.exLngIds)
      this.$parent.stypes = this.convertIdToTags(rule.exTypeIds)
      this.$parent.sowner = rule.exIsOwner
      this.$parent.spublic = rule.exIsPublic
      this.$parent.sTagFilter = rule.exTagFilterType
      this.$parent.editRuleId = rule.id
      window.jQuery('#modal-addRule').modal('toggle')
    },
    convertIdToTags (tagIdList) {
      let tags = []
      for (let i = 0; i < tagIdList.length; i++) {
        tags.push(this.getTagFromId(tagIdList[i]))
      }
      return tags
    },
    getTagFromId (tagId) {
      for (let i = 0; i < this.options.tags.length; i++) {
        if (this.options.tags[i].id === tagId) {
          return this.options.tags[i]
        }
      }
      for (let i = 0; i < this.options.lngs.length; i++) {
        if (this.options.lngs[i].id === tagId) {
          return this.options.lngs[i]
        }
      }
      for (let i = 0; i < this.options.types.length; i++) {
        if (this.options.types[i].id === tagId) {
          return this.options.types[i]
        }
      }
      return tagId
    },
    tagName (tagId) {
      if (this.options.tags) {
        for (let i = 0; i < this.options.tags.length; i++) {
          if (this.options.tags[i].id === tagId) {
            return this.options.tags[i].name
          }
        }
      }
      return tagId
    },
    languageName (tagId) {
      if (this.options.lngs) {
        for (let i = 0; i < this.options.lngs.length; i++) {
          if (this.options.lngs[i].id === tagId) {
            return this.options.lngs[i].name
          }
        }
      }
      return tagId
    },
    typeName (tagId) {
      if (this.options.types) {
        for (let i = 0; i < this.options.types.length; i++) {
          if (this.options.types[i].id === tagId) {
            return this.options.types[i].name
          }
        }
      }
      return tagId
    },
    deleteRuleModal (ruleId) {
      this.$parent.editRuleId = ruleId
      window.jQuery('#modal-beforeDelete').modal('toggle')
    },
    deleteRule (ruleId) {
      return Rest.request('DELETE', '/subgroups/any/rules/' + ruleId).then((data) => {
        for (let i = 0; i < this.rules.length; i++) {
          if (this.rules[i].id === ruleId) {
            this.rules.splice(i, 1)
            break
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getOptions () {
      return Rest.request('GET', '/exercises/searchOptions').then((data) => {
        this.options = data
      }).catch((err) => {
        console.log(err)
      })
    },
    getRules () {
      return Rest.request('GET', '/subgroups/' + this.podgrupa.id + '/rules').then((data) => {
        this.rules = data
      }).catch((err) => {
        console.log(err)
      })
    },
    addRule () {
      this.$parent.editRuleId = null
      this.toggleAddRuleMdal()
    },
    toggleAddRuleMdal () {
      window.jQuery('#modal-addRule').modal('toggle')
    },
    toggleExercisesModal () {

    },
    addExercisesBulk () {

    },
    addExercises () {
      this.$store.commit('addExercisesToSubgroup', this.podgrupa.id)
      window.jQuery('#modal-exercises-add').modal('toggle')
    },
    toggleExercisePreview (id) {
      // alert(id)
      window.jQuery('#modal-show-exercise').modal('toggle')
      this.$store.dispatch('updateModalForExercise', id).then((el) => {
        // this.$nextTick(function () {
        //   window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
        // })
        // window.jQuery('#mo').modal('toggle')
        // window.jQuery('.modal-backdrop').remove()
      })
    },
    deleteExercise (exerId, subgroupId) {
      this.$store.dispatch('eraseExerciseFromSubgroup', {
        subgroupId: subgroupId,
        exerciseIds: exerId
      }).then(() => {
        this.exercisesForProgress.splice(this.exercisesForProgress.map(item => item.exerciseId).indexOf(exerId), 1)
      }).catch((err) => {
        alert(err.responseJSON.message)
      })
    },
    changeVisibility (exer) {
      let putData = {
        visible: !exer.visible
      }
      return Rest.request('PUT', '/subgroups/exercises/' + exer.id, putData).then((data) => { // TODO: should be false in production
        exer.visible = !exer.visible
      }).catch((err) => {
        console.log(err)
      })
    },
    exercisesForProgressGet () {
      return Rest.request('GET', `/groups/${this.$route.params.gid}/years/${this.$route.params.yid}/subgroups/${this.podgrupa.id}`).then((data) => { // TODO: should be false in production
        this.exercisesForProgress = data.subgroupExercises
      }).catch((err) => {
        console.log(err)
      })
    },
    closeDropdown () {
      this.$set(this.podgrupa, 'showOrder', !this.podgrupa.showOrder)
      Rest.request(`GET`, `/groups/${this.$route.params.gid}/years/${this.$route.params.yid}/subgroups/${this.$route.params.sid}`).then((data) => {
        for (let i = 0; i < data.subgroups.length; i++) {
          if (data.subgroups[i].id === this.podgrupa.id) {
            this.$set(this.podgrupa, 'totalQuestionsCount', data.subgroups[i].totalQuestionsCount)
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  watch: {
    exercisesForProgress (val) {
      let putData = {
        subgroupId: this.podgrupa.id,
        // orders: contex.getters.getNewOrderOfExercises
        orders: val.map(exer => exer.id)
      }
      return Rest.request('PUT', '/subgroups/exercises/order/' + this.podgrupa.id, putData).then((data) => {
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  components: {
    draggable,
    'exercise': Exercise,
    'v-select': vSelect
  }
}
</script>

<style scoped>
.tekst {
color: black;
}
.btn-block {
  display:block;
  float:left;
  background-color: #008d4c ;
}
.btn-block:hover {
  background-color: #008044 ;
}
.btn-block:focus {
  background-color: #008044;
  border-color: #255625;
}
.my-margin {
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.list-group-item:hover {
  background-color: lightgrey;
}
.badge {
  cursor: pointer;
}
.fa-caret-up {
  color: white
}
.panel-transparent {
  background: none;
}

.panel-transparent .panel-heading{
  background: rgba(122, 130, 136, 0.1)!important;
}

.panel-transparent .panel-body{
  background: rgba(46, 51, 56, 0.1)!important;
}

</style>



// WEBPACK FOOTER //
// EditSubgroupRules.vue?31971e42